import { useState, useEffect, useCallback, useRef } from 'react';
import { getApiListings, Listing } from "../api/listings-client";

interface UseListingsProps {
    postcodes?: string[];
    localities?: string[];
}

export const useListings = ({ postcodes = [], localities = [] }: UseListingsProps = {}) => {
    const [listings, setListings] = useState<Array<Listing>>([]);
    const [isLoading, setIsLoading] = useState(true);
    const hasLoaded = useRef(false);

    const fetchListings = useCallback(async () => {
        if (hasLoaded.current) return;
        try {
            setIsLoading(true);
            const response = await getApiListings({ postcodes, localities });

            if (response.listings) {
                setListings(response.listings);
            }
        } catch (error) {
            console.error('Error fetching listings:', error);
            setListings([]); // Set empty array on error
        } finally {
            setIsLoading(false);
            hasLoaded.current = true;
        }
    }, [postcodes, localities]);

    useEffect(() => {
        fetchListings();
    }, [fetchListings]);

    return {
        listings,
        isLoading,
        refetch: () => {
            hasLoaded.current = false;
            fetchListings();
        }
    };
};
